export default {
    START_ASYNC_CALL: `START_ASYNC_CALL`,
    ERROR_ASYNC_CALL: `ERROR_ASYNC_CALL`,
    ENVIRONMENT: {
        SET: `SET_ENVIRONMENT_SUCCESS`
    },
    USER: {
        SET_LOGGED_IN: `SET_LOGGED_IN`,
        UPDATE: `UPDATE`
    },
    CUSTOMERS: {
        SET: `SET_CUSTOMERS_SUCCESS`,
        SET_SHOW_VOT_ORDER_ID: `SET_SHOW_VOT_ORDER_ID_SUCCESS`,
        SET_VEHICLES: `SET_CUSTOMER_VEHICLES_SUCCESS`,
        SET_SUBSCRIPTIONS: `SET_CUSTOMER_SUBSCRIPTIONS_SUCCESS`,
        SET_ORDERS: `SET_CUSTOMER_ORDERS_SUCCESS`,
        SET_ORDER_DETAILS: `SET_ORDER_DETAILS_SUCCESS`,
        SET_PREFERRED_DEALER: `SET_PREFERRED_DEALER_SUCCESS`,
        SORT: `CUSTOMER_SORT`,
        CHANGE_CULTURE: `CHANGE_CUSTOMER_CULTURE`,
        SET_GROUPS: `SET_GROUPS`
    },
    VEHICLE: {
        SET: `SET_VEHICLE_SUCCESS`,
        DELETE_DEVICE: `DELETE_DEVICE_SUCCESS`
    },
    CULTURE: {
        SET_COUNTRIES: `SET_COUNTRIES_SUCCESS`,
        SET_LANGUAGES: `SET_LANGUAGES_SUCCESS`,
        SET_ALL_LANGUAGES: `SET_ALL_LANGUAGES_SUCCESS`
    }
};
